import axios from 'axios'

export default {
  state: {
    response: {
      registrars: []
    },
    errors: {
      getRegistrars: null
    },
    loading: {
      getRegistrars: false
    },
    total: null
  },
  mutations: {
    GET_REGISTRARS_LIST_SUCCESS(state, payload) {
      state.response.registrars = payload.operators
      state.total = payload.total
      state.errors.getRegistrars = null
      state.loading.getRegistrars = false
    },
    GET_REGISTRARS_LIST_ERROR(state, error) {
      state.errors.getRegistrars = error
      state.loading.getRegistrars = false
    },
    CLEAR_OPERATORS(state) {
      state.response.registrars = []
    }
  },
  actions: {
    GET_OPERATORS_LIST({ commit, state, dispatch }, data) {
      const sessionId = sessionStorage.getItem('token')
      state.loading.getRegistrars = true
      return axios({
        method: 'POST',
        url: `/api/CustomerRegistration/GetOperators/${sessionId}`,
        data
      })
        .then(response => {
          commit('GET_REGISTRARS_LIST_SUCCESS', response.data)
        })
        .catch(error => {
          commit('GET_REGISTRARS_LIST_ERROR', error.response.data.message)
          dispatch('NOTIFICATION', { open: true, color: 'error', text: error.response.data.message })
        })
    }
  }
}
